// extracted by mini-css-extract-plugin
module.exports = {"container":"antd-pro-components-page-search-index-container"};